// `minWidth` is derived from the longest option (Aptos).
export const tokens = {
    padding: 16,
    minWidth: 100,
    height: 40,
    fontSize: 14,
    iconSize: 14,
    menu: {
        radius: 10,
        list: {
            gap: 2,
            padding: 4,
        },
        option: {
            gap: 8,
            radius: 6,
            padding: {
                x: 8,
                y: 4,
            },
        },
        symbol: {
            size: 20,
            iconSize: 12,
        },
    },
};
